export function LoadingState() {
  return (
    <main className="grid min-h-screen place-items-center bg-background p-6">
      <p className="text-sm text-muted-foreground">Carregando Lisboon...</p>
    </main>
  );
}
